import { Controller } from "@hotwired/stimulus"
import { TempFormHelper } from "~/helpers/temp_form_helper"

export default class extends Controller {
  static get targets() {
    return ["search", "option", "addFolder", "newFolderName"]
  }

  static get values() {
    return {
      filters: { type: Object, default: {} },
      selectedCompanyListIds: { type: Array, default: [] },
      folderManagementUrl: String,
    }
  }

  search() {
    const searchValue = this.searchTarget.value.toLowerCase()
    let anySameName = false

    this.optionTargets.forEach((option) => {
      let optionName = option.dataset.name.toLowerCase()
      if (optionName === searchValue) {
        anySameName = true
      }

      if (optionName.includes(searchValue)) {
        option.classList.remove("d-none")
      } else {
        option.classList.add("d-none")
      }
    })

    if (searchValue !== "" && !anySameName) {
      this.addFolderTarget.classList.remove("d-none")
      this.newFolderNameTarget.textContent = this.searchTarget.value
    } else {
      this.addFolderTarget.classList.add("d-none")
      this.newFolderNameTarget.textContent = ""
    }
  }

  addFolder() {
    if (this.addFolderTarget.classList.contains("d-none")) {
      return
    }

    const formElement = this._tempForm({ folderName: this.searchTarget.value })

    formElement.addEventListener("turbo:submit-end", () => {
      this.searchTarget.value = ""
      this.addFolderTarget.classList.add("d-none")
      this.newFolderNameTarget.textContent = ""
      this.optionTargets.forEach((option) => {
        option.classList.remove("d-none")
      })
    })

    formElement.requestSubmit()
  }

  setFolder({ params: { folderId } }) {
    this._tempForm({ folderId: folderId }).requestSubmit()
  }

  _tempForm({ folderId, folderName }) {
    if (!folderId && !folderName) {
      return
    }

    return TempFormHelper.create("/company-lists/bulk", "patch", (form) => {
      if (folderId) {
        TempFormHelper.addHiddenInput(form, "company_list_folder_id", folderId)
      }

      if (folderName) {
        TempFormHelper.addHiddenInput(form, "company_list_folder_name", folderName)
      }

      if (this.selectedCompanyListIdsValue.length > 0) {
        this.selectedCompanyListIdsValue.forEach((id) => {
          TempFormHelper.addHiddenInput(form, "company_list_ids[]", id)
        })
      } else {
        Object.entries(this.filtersValue).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach((item) => {
              TempFormHelper.addHiddenInput(form, `${key}[]`, item)
            })
          } else {
            TempFormHelper.addHiddenInput(form, key, value)
          }
        })
      }
    })
  }

  // This action is used to update the selected leads lists value and update the text in the modal based on the number
  // of leads lists.
  // We trigger this using the check-all controller.
  updateSelection(event) {
    if (event.detail.allSelected) {
      this.selectedCompanyListIdsValue = []
    } else if (event.detail.dataSets) {
      this.selectedCompanyListIdsValue = event.detail.dataSets.map((dataSet) => dataSet.recordId).filter(Boolean)
    } else {
      this.selectedCompanyListIdsValue = []
    }
  }
}
